module.exports = __webpack_public_path__ + "components/country-flag/static/ru-f08093ff2c34cb6b834f2bac44116e41.svg";